import React from 'react';
import PropTypes from 'prop-types';
import { compose, MODULE_TYPE } from '../../../services/utilityFunctions';
import translate from '../../../commonComponents/translate';
import withCSRF from '../../../commonComponents/withCSRF';
import Modal from '../../../commonComponents/modal/Modal';
import CourseProp from '../propTypes/courseProp';
import JourneyBannerAllRewards from '../list/journeyBanner/JourneyBannerAllRewards';
import { REWARD_TYPE } from '../list/journeyBanner/JourneyBannerNextReward';

function EndCourseModal({ t, onClose, course }) {
  const rewards = course.rewards || {};
  const coupons =
    rewards.coupons && rewards.coupons.length > 0
      ? {
          type: REWARD_TYPE.COUPON,
          items: (rewards.coupons || []).map(c =>
            c.image ? c.image.thumb : '/images/no_image_upload.png',
          ),
        }
      : null;
  const vouchers =
    rewards.vouchers && rewards.vouchers.length > 0
      ? {
          type: REWARD_TYPE.VOUCHER,
          items: (rewards.vouchers || []).map(v =>
            v.logo ? v.logo.thumb : '/images/no_images_upload.png',
          ),
        }
      : null;
  const coins =
    rewards.coins && rewards.coins.winner > 0
      ? {
          type: REWARD_TYPE.COINS,
          coins: { wallet: rewards.coins.winner },
        }
      : null;
  const rewardsToDisplay = coins || coupons || vouchers;
  const image = course.imageSquare || course.image;

  const certificate = (course.modulesList || []).find(
    m => m.type === MODULE_TYPE.CERTIFICATE,
  );

  const CertificateButton = () => (
    <button
      type="button"
      style={{ textTransform: 'uppercase' }}
      className="btn btn-dynamic"
      onClick={() => onClose(certificate._id)}
    >
      {t('academyDetails_seeCertificate')}
    </button>
  );

  const CourseButton = () => (
    <button
      type="button"
      style={{ textTransform: 'uppercase' }}
      className="btn btn-metal"
      onClick={() => {
        window.location.href = '/academy';
      }}
    >
      {t('academyDetails_seeMore')}
    </button>
  );

  const JourneysButton = () => (
    <button
      type="button"
      style={{ textTransform: 'uppercase' }}
      className="btn btn-dynamic"
      onClick={() => {
        window.location.href = '/academy/journeys';
      }}
    >
      {t('academyDetails_seeJourneys')}
    </button>
  );

  return (
    <Modal onClose={onClose}>
      <div
        className="modal-dialog modal-dialog-centered modal-journey"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <div className="image-modal">
              <img
                src={image ? image.thumb : '/images/no_image_upload.png'}
                alt="course"
              />
            </div>
            {onClose && (
              <button
                type="button"
                className="close"
                onClick={onClose}
                style={{ zIndex: 20 }}
              >
                <span aria-hidden="true">×</span>
              </button>
            )}
          </div>
          <div className="modal-body">
            <div className="container-fluid">
              <h3 className="congratulations">
                {t('journey_congratulations')}
              </h3>
              <p style={{ whiteSpace: 'pre-wrap' }}>
                {t('academyDetails_finished1')}
                <span className="text-dynamic">{course.name}</span>
                {t('academyDetails_finished2')}
                {rewardsToDisplay && (
                  <>
                    <br />
                    {t('academyDetails_hereReward')}
                  </>
                )}
              </p>
              {rewardsToDisplay && (
                <div className="row">
                  <div className="col-lg-12 journey-next end-course-rewards">
                    <JourneyBannerAllRewards {...rewardsToDisplay} centered />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            {rewardsToDisplay ? (
              <>{certificate && <CertificateButton />}</>
            ) : (
              <>
                <CourseButton />
                {certificate ? <CertificateButton /> : <JourneysButton />}
              </>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}

EndCourseModal.propTypes = {
  t: PropTypes.func.isRequired,
  course: PropTypes.shape(CourseProp.propType).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default compose(withCSRF, translate)(EndCourseModal);
